import { render } from "./Bag.vue?vue&type=template&id=1060a1f8&scoped=true"
import script from "./Bag.vue?vue&type=script&lang=js"
export * from "./Bag.vue?vue&type=script&lang=js"

import "./Bag.vue?vue&type=style&index=0&id=1060a1f8&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1060a1f8"]])

export default __exports__